export default __webpack_public_path__ + "static/media/shareBlack.6f41aef2.svg";